import axios from 'axios';
import { toastr } from 'react-redux-toastr';
import { createAction } from 'redux-act';
import { url } from 'utils/url';
import { log, errorMsg, refreshToken } from 'utils';
import { getCsrf } from 'components/Report/utils';

export const CATEGORIES_FETCH_DATA_INIT = createAction(
  'CATEGORIES_FETCH_DATA_INIT'
);
export const CATEGORIES_FETCH_DATA_SUCCESS = createAction(
  'CATEGORIES_FETCH_DATA_SUCCESS'
);
export const CATEGORIES_FETCH_DATA_FAIL = createAction(
  'CATEGORIES_FETCH_DATA_FAIL'
);

export const CATEGORIES_DELETE_CATEGORY_INIT = createAction(
  'CATEGORIES_DELETE_CATEGORY_INIT'
);
export const CATEGORIES_DELETE_CATEGORY_SUCCESS = createAction(
  'CATEGORIES_DELETE_CATEGORY_SUCCESS'
);
export const CATEGORIES_DELETE_CATEGORY_FAIL = createAction(
  'CATEGORIES_DELETE_CATEGORY_FAIL'
);

export const CATEGORIES_CLEAR_DATA = createAction('CATEGORIES_CLEAR_DATA');

export const CATEGORIES_CREATE_CATEGORY_INIT = createAction(
  'CATEGORIES_CREATE_CATEGORY_INIT'
);
export const CATEGORIES_CREATE_CATEGORY_SUCCESS = createAction(
  'CATEGORIES_CREATE_CATEGORY_SUCCESS'
);
export const CATEGORIES_CREATE_CATEGORY_FAIL = createAction(
  'CATEGORIES_CREATE_CATEGORY_FAIL'
);

export const CATEGORIES_MODIFY_CATEGORY_INIT = createAction(
  'CATEGORIES_MODIFY_CATEGORY_INIT'
);
export const CATEGORIES_MODIFY_CATEGORY_SUCCESS = createAction(
  'CATEGORIES_MODIFY_CATEGORY_SUCCESS'
);
export const CATEGORIES_MODIFY_CATEGORY_FAIL = createAction(
  'CATEGORIES_MODIFY_CATEGORY_FAIL'
);

export const CATEGORIES_CLEAN_UP = createAction('CATEGORIES_CLEAN_UP');

export const CATEGORIES_CLEAR_DATA_LOGOUT = createAction(
  'CATEGORIES_CLEAR_DATA_LOGOUT'
);

export const SET_CATEGORY = createAction('SET_CATEGORY');

axios.defaults.withCredentials = true;

export const fetchCategories = ({ categoryId, siteId }) => {
  return async (dispatch, getState) => {
    dispatch(CATEGORIES_FETCH_DATA_INIT());
    if (categoryId) {
      let categoryData;
      try {
        const token = await refreshToken();
        categoryData = await axios.get(`${url}/poiCategory/list`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
      } catch (error) {
        toastr.error('', `${errorMsg(dispatch, error)}`);
        return dispatch(CATEGORIES_FETCH_DATA_FAIL({ error }));
      }
      const category = { ...categoryData, id: categoryId };
      return dispatch(
        CATEGORIES_FETCH_DATA_SUCCESS({
          list: getState().categories.list,
          category,
        })
      );
    }

    if (siteId) {
      let categories;
      try {
        const token = await refreshToken();
        categories = await axios.get(`${url}/poiCategory/list`, {
          params: {
            siteId,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
      } catch (error) {
        toastr.error('', `${errorMsg(dispatch, error)}`);
        return dispatch(CATEGORIES_FETCH_DATA_FAIL({ error }));
      }
      categories = categories.data.data.filter(
        (category) => category.siteId === siteId
      );

      return dispatch(
        CATEGORIES_FETCH_DATA_SUCCESS({
          list: categories,
          category: getState().categories.category,
        })
      );
    }
  };
};

export const deleteCategory = (id, cb) => {
  return async (dispatch, getState) => {
    dispatch(CATEGORIES_DELETE_CATEGORY_INIT());

    try {
      const csrfToken = await getCsrf();
      const token = await refreshToken();
      await axios.delete(`${url}/poiCategory/delete`, {
        params: {
          id,
        },
        headers: {
          Authorization: `Bearer ${token}`,
          'X-CSRF-TOKEN': csrfToken,
        },
        withCredentials: true,
      });
    } catch (error) {
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('', errorMessage, { icon: 'error' });
      return dispatch(
        CATEGORIES_DELETE_CATEGORY_FAIL({
          error: errorMessage,
        })
      );
    }

    toastr.success('', 'The category was deleted.');
    cb();
    return dispatch(CATEGORIES_DELETE_CATEGORY_SUCCESS({ id }));
  };
};

export const clearCategoriesData = () => {
  return (dispatch) => {
    dispatch(CATEGORIES_CLEAR_DATA());
  };
};

export const clearCategoriesDataLogout = () => {
  return (dispatch) => {
    dispatch(CATEGORIES_CLEAR_DATA_LOGOUT());
  };
};

export const createCategory = (
  { uid, name, description, siteId, modifiedAt, modifiedBy },
  cb
) => {
  return async (dispatch, getState) => {
    dispatch(CATEGORIES_CREATE_CATEGORY_INIT());
    let category;
    try {
      const csrfToken = await getCsrf();
      const token = await refreshToken();
      category = await axios.post(
        `${url}/poiCategory/create`,
        {
          name,
          description,
          siteId,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'X-CSRF-TOKEN': csrfToken,
          },
          withCredentials: true,
        }
      );
    } catch (error) {
      log(error.response, '<<< error response');
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('', errorMessage);
      return dispatch(
        CATEGORIES_CREATE_CATEGORY_FAIL({
          error: error && error.response && error.response.data,
        })
      );
    }
    toastr.success('', 'Category created successfully');
    cb();
    dispatch(
      SET_CATEGORY({
        data: {
          name: '',
          description: '',
        },
      })
    );

    return dispatch(
      CATEGORIES_CREATE_CATEGORY_SUCCESS({ category: category.data.data })
    );
  };
};

export const modifyCategory = (
  { id, name, description, siteId, modifiedAt, modifiedBy },
  cb
) => {
  return async (dispatch, getState) => {
    dispatch(CATEGORIES_MODIFY_CATEGORY_INIT());

    const categoryData = {
      id,
      name,
      description,
      siteId,
      modifiedAt,
      modifiedBy,
    };

    console.log(categoryData);
    const csrfToken = await getCsrf();
    const token = await refreshToken();
    const updateCategoryDbTask = axios.post(
      `${url}/poiCategory/edit`,
      categoryData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'X-CSRF-TOKEN': csrfToken,
        },
        withCredentials: true,
      }
    );

    try {
      await Promise.all([updateCategoryDbTask]);
    } catch (error) {
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('', errorMessage);

      return dispatch(
        CATEGORIES_MODIFY_CATEGORY_FAIL({
          error: error && error.response && error.response.data,
        })
      );
    }

    toastr.success('', 'Category updated successfully');
    cb();
    dispatch(
      SET_CATEGORY({
        data: {
          name: '',
          description: '',
        },
      })
    );
    return dispatch(
      CATEGORIES_MODIFY_CATEGORY_SUCCESS({ category: categoryData, id })
    );
  };
};

export const categoriesCleanUp = () => (dispatch) =>
  dispatch(CATEGORIES_CLEAN_UP());

export const setCategory = (data, cb) => {
  return (dispatch) => {
    dispatch(SET_CATEGORY({ data }));
    if (cb) {
      cb();
    }
  };
};
